class CountdownTimer extends HTMLElement {

  constructor() {
    super()
    this.intervalId = null
  }

  connectedCallback() {
    this.init()
  }

  disconnectedCallback() {
    this.clearTimer()
  }

  clearTimer() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }
  }

  init() {
    this.clearTimer()

    const dateEl = this.querySelector('.countdown-timer__date')
    if (!dateEl) {
      return
    }

    const targetDate = new Date(dateEl.dataset.targetDate)
    if (Number.isNaN(targetDate.getTime())) {
      return
    }

    this.tick(dateEl, targetDate)
    this.intervalId = setInterval(() => {
      this.tick(dateEl, targetDate)
    }, 1000)
    this.showCountdownTimer()
  }

  tick(dateEl, targetDate) {
    const diff = Math.max(0, targetDate.getTime() - Date.now());
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    const setValue = (type, value) => {
      const el = dateEl.querySelector(`.countdown-timer__date__item__number[data-type="${type}"]`)
      if (el) {
        el.textContent = String(value).padStart(2, '0')
      }
    }

    setValue('day', days)
    setValue('hour', hours)
    setValue('min', minutes)
    setValue('sec', seconds)

    if (diff === 0) {
      this.clearTimer()
      this.hideCountdownTimer()
    }
  }

  showCountdownTimer() {
    const section = this.closest('.countdown-timer-section')
    if (!section) {
      return
    }

    section.classList.remove('hidden')
  }

  hideCountdownTimer() {
    const section = this.closest('.countdown-timer-section')
    if (!section) {
      return
    }

    section.classList.add('hidden')
  }

}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer)
}
